<template>
  <div class="min-table-box">
    <div class="pre-box">
      <strong>Post: </strong>
      <span>EXPLORA PATAGONIA HOTEL SALTO CHICO</span>
      <a @click="handleAdd"><a-icon type="plus"/></a>
    </div>
    <a-table :columns="columns" :data-source="data" bordered :pagination="false">
      <template
        slot="ofRm"
        slot-scope="text, record"
      >
        <div :key="ofRm">
          <a-input
            v-if="record.editable"
            :value="text"
            @change="e => handleChange(e.target.value, record.key, ofRm)"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>

      <template
        slot="roomType"
        slot-scope="text, record"
      >
        <div :key="roomType">
          <a-select
            v-if="record.editable"
            :value="text"
            @change="e => handleChange(e, record.key, roomType)"
          >
            <a-select-option value="SG">
              SG
            </a-select-option>
            <a-select-option value="DBL">
              DBL
            </a-select-option>
            <a-select-option value="TW">
              TW
            </a-select-option>
            <a-select-option value="TRI">
              TRI
            </a-select-option>
          </a-select>
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      
      <template
        slot="bkName"
        slot-scope="text, record"
      >
        <div :key="bkName">
          <a-select
            v-if="record.editable"
            :value="text"
            mode="multiple"
            @change="e => handleChange(e, record.key, bkName)"
          >
            <a-select-option value="Tim Liu">
              Tim Liu
            </a-select-option>
            <a-select-option value="Nian Cheng">
              Nian Cheng
            </a-select-option>
          </a-select>
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>

      <template
        slot="nights"
        slot-scope="text, record"
      >
        <div :key="nights">
          <a-input
            v-if="record.editable"
            :value="text"
            @change="e => handleChange(e.target.value, record.key, nights)"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      
      <template
        slot="remark"
        slot-scope="text, record"
      >
        <div :key="remark">
          <a-textarea
            auto-size
            v-if="record.editable"
            :value="text"
            @change="e => handleChange(e.target.value, record.key, remark)"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>

      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a-popconfirm 
              title="Are you sure?" 
              @confirm="() => save(record.key)"
              ok-text="Yes" 
              cancel-text="No"
            >
              <a class="link-btn link-btn-right">SUB</a>
            </a-popconfirm>
            <a class="link-btn" @click="() => cancel(record.key)">CXL</a>
          </span>
          <span v-else>
            <a class="link-btn link-btn-right" :disabled="editingKey !== ''" @click="() => edit(record.key)">EDT</a>
            <a-popconfirm 
              title="Sure to cancel?" 
              @confirm="() => onDelete(record.key)" 
              v-if="data.length"
              ok-text="Yes" 
              cancel-text="No"
            >
              <a class="link-btn">CXL</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    title: '# RM',
    dataIndex: 'ofRm',
    width: '60px',
    scopedSlots: { customRender: 'ofRm' },
  },
  {
    title: 'RM type',
    dataIndex: 'roomType',
    scopedSlots: { customRender: 'roomType' },
  },
  {
    title: 'Guests',
    dataIndex: 'bkName',
    scopedSlots: { customRender: 'bkName' },
  },
  {
    title: '# Nt',
    dataIndex: 'nights',
    width: '60px',
    scopedSlots: { customRender: 'nights' }
  },
  {
    title: 'Rate/R/N',
    dataIndex: 'rates',
    scopedSlots: { customRender: 'rates' }
  },
  {
    title: 'Ch-in',
    dataIndex: 'checkIn',
    scopedSlots: { customRender: 'checkIn' }
  },
  {
    title: 'Ch-out',
    dataIndex: 'checkOut',
    scopedSlots: { customRender: 'checkOut' }
  },
  {
    title: 'Remark',
    dataIndex: 'remark',
    scopedSlots: { customRender: 'remark' }
  },
  {
    title: 'Submit',
    dataIndex: 'submit',
    scopedSlots: { customRender: 'submit' }
  },
  {
    title: 'Confirm',
    dataIndex: 'confirm',
    scopedSlots: { customRender: 'confirm' }
  },
  {
    title: 'Action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    scopedSlots: { customRender: 'subtotal' }
  }
]

const data = [
  {
    key: '0',
    ofRm: '2',
    roomType: 'TW',
    bkName: 'Jason Peng',
    nights: '1',
    rates: '$315',
    checkIn: '02/21/2022',
    checkOut: '02/22/2022',
    remark: 'Text',
    submit: 'Jason',
    confirm: '',
    status: 'SUB',
    subtotal: '$315'
  },
  {
    key: '1',
    ofRm: '2',
    roomType: 'SG',
    bkName: 'Nian Chen',
    nights: '1',
    rates: '$315',
    checkIn: '02/21/2022',
    checkOut: '02/22/2022',
    remark: 'Text',
    submit: 'Jason',
    confirm: '',
    status: 'SUB',
    subtotal: '$315'
  },
  {
    key: '2',
    ofRm: '3',
    roomType: 'TRI',
    bkName: 'Jason Peng',
    nights: '1',
    rates: '$315',
    checkIn: '02/21/2022',
    checkOut: '02/22/2022',
    remark: 'Text',
    submit: 'Jason',
    confirm: '',
    status: 'SUB',
    subtotal: '$315'
  },
  {
    key: '3',
    ofRm: '4',
    roomType: 'TW',
    bkName: 'Liu Tim',
    nights: '1',
    rates: '$315',
    checkIn: '02/21/2022',
    checkOut: '02/22/2022',
    remark: 'Text',
    submit: 'Jason',
    confirm: '',
    status: 'SUB',
    subtotal: '$315'
  }
]

export default {
  name: '',
  components: {
  },
  props: {
  },
  data () {
    this.cacheData = data.map(item => ({ ...item }))
    return {
      data,
      columns,
      editingKey: '', 
      nights:'nights',
      ofRm: 'ofRm',
      bkName: 'bkName',
      roomType: 'roomType',
      remark: 'remark',
      count: 4,
    }
  },
  mounted () {
  },
  methods: {
     handleChange(value, key, column) {
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target[column] = value
        this.data = newData
      }
    },
    edit(key) {
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      this.editingKey = key
      if (target) {
        target.editable = true
        this.data = newData
      }
    },
    save(key) {
      const newData = [...this.data]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.key)[0]
      const targetCache = newCacheData.filter(item => key === item.key)[0]
      if (target && targetCache) {
        delete target.editable
        this.data = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
      this.editingKey = ''
    },
    cancel(key) {
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter(item => key === item.key)[0])
        delete target.editable
        this.data = newData
      }
    },
    onDelete(key) {
      const data = [...this.data]
      this.data = data.filter(item => item.key !== key)
    },
    handleAdd() {
      const { count, data } = this
      const newData = {
        key: count,
        ofRm: '1',
        roomType: 'TW',
        bkName: 'Liu Tim',
        nights: '1',
        rates: '$315',
        checkIn: '02/21/2022',
        checkOut: '02/22/2022',
        remark: 'Text',
        submit: 'Jason',
        confirm: '',
        status: 'SUB',
        subtotal: '$315'
      }
      this.data = [...data, newData]
      this.count = count + 1
    },
  }
}
</script>
<style lang="less" scoped>
</style>